<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="Group" prop="configGroup" >
        <a-input v-model="form.configGroup" :disabled='formType == 2' placeholder="Enter group" />
      </a-form-model-item>
      <a-form-model-item label="Variable key"  prop="configName" >
        <a-input v-model="form.configName" :disabled='formType == 2' placeholder="Enter variable key" />
      </a-form-model-item>
      <a-form-model-item label="Title" prop="title" >
        <a-input v-model="form.title" placeholder="Enter title" />
      </a-form-model-item>

      <a-form-model-item label="Parameter type" prop="type">
        <a-radio-group v-model="form.type" button-style="solid">
          <a-radio-button v-for="(d, index) in  configTypeOptions" :key="index" :value="d.value">
            {{ d.label }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="Value" prop="configValue" >
        <a-textarea v-model="form.configValue" placeholder="Enter value" v-if="form.type== 1 " />
        <editor id="configValueId" v-if="form.type == 2" v-model="form.configValue"  ></editor>
        <a-input-number style="width: 100%;" v-if="form.type == 3"  v-model="form.configValue" placeholder="Enter number"  :min='0'/>
        <a-upload v-if="form.type == 4"  listType='picture-card'
                  class='avatar-uploader' :show-upload-list='false' :beforeUpload='(info) => fileBeforeUpload("configValue",info)'
                  :customRequest='(info) => fileUploadRequest("configValue",info)' v-model="form.configValue">
          <img v-if="form.type ==4 && form.configValue != null" :src='form.configValue' style='height:104px;max-width:300px' />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class='ant-upload-text'>{{ loading ? 'Uploading...' : 'Upload' }}</div>
          </div>
        </a-upload>
      </a-form-model-item>


      <a-form-model-item label="Description" prop="description" >
        <a-input v-model="form.description" placeholder="Enter description" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            Save
          </a-button>
          <a-button type="dashed" @click="cancel">
            Cancel
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getConfig, addConfig, updateConfig } from '@/api/app/config'
import Editor from '@/components/Editor'
import UploadFileToOSS from '@/utils/upload-file-to-oss'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      configTypeOptions: [{"value":1,"label":"Text"},{"value":2,"label":"Rich text"},{"value":3,"label":"Number"},{"value":4,"label":"Image"}],
      // 表单参数
      form: {
        id: null,

        configGroup: null,

        configName: null,

        title: null,

        description: null,

        configValue: null,

        configValueEn: null,

        type: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      uploadLoading:false,
      rules: {
        configGroup: [
          { required: true, message: 'Group is required', trigger: 'blur' }
        ],
        configName: [
          { required: true, message: 'Variable key is required', trigger: 'blur' }
        ],
        title: [
          { required: true, message: 'Title is required', trigger: 'blur' }
        ],
        configValue: [
          { required: true, message: 'Value is required', trigger: 'blur' }
        ],

        type: [
          { required: true, message: 'Type is required', trigger: 'change' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        configGroup: null,
        configName: null,
        title: null,
        description: null,
        configValue: null,
        configValueEn: null,
        type: 1,
        createTime: null,
        remark: null,
      }
      // this.$nextTick(() => {
      //   if(this.$refs.form){
      //     this.$refs.form.resetFields()
      //   }
      // })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = 'Add'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getConfig({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = 'Edit'
      })
    },
    /**
     * 文件上传前校验
     * @param {config.form.item} formItem 表单项
     * @param {*} fileInfo 文件详情, 见 a-upload 组件 customRequest 事件
     */
    fileBeforeUpload(field,fileInfo) {
      // 图片类型字段, 进行文件类型判断
      if (!fileInfo.type.includes('image')) {
        this.$message.warning('Please upload an image');
        return false;
      }
      return true;
    },
    /**
     * 文件上传请求自定义
     * @param {config.form.item} formItem 表单项
     * @param {*} fileInfo 文件详情, 见 a-upload 组件 customRequest 事件
     */
    fileUploadRequest(field,fileInfo) {


      this.loading = true;
      new UploadFileToOSS([fileInfo.file], {
        finally: (res) => {

          this.loading = false;
          this.form.configValue = res[0].url;
        },
      });
    },
    beforeUploadEn: function (file) {
      var fileType = file.type;
      if (fileType.indexOf('image') < 0) {
        this.$message.warning('Please upload an image');
        this.uploadLoading=false
        return false;
      }
      this.form.configValueEn=""
      //TODO 驗證文件大小
    },
    handleChangeEn(info) {

      let that = this
      this.uploadLoading = true;
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.configValueEn = fileName[0];//文件名
          that.uploadLoading = false;
        },
      });
      that.uploadLoading = false;

    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateConfig(this.form).then(response => {
              this.$message.success(
                'Updated successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addConfig(this.form).then(response => {
              this.$message.success(
                'Created successfully',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
